export default (config) => ({
    // PROPS
    tracks  : config.tracks || [],
    playAll : config.playAll || false,
    autoplay: config.autoplay || false,
    //variables for playAll player mode
    masterIndex     : config.masterIndex ?? 0,
    autoReplayOthers: config.autoReplayOthers ?? false,
    nonMasterVolume : config.nonMasterVolume ?? 0.5,

    // ESTADO
    isPlaying      : false,
    currentIndex   : 0,
    currentTime    : 0,
    duration       : 0,
    progressPercent: 0,

    // GETTERS para formatear tiempo
    get formattedCurrentTime() {
        return this.formatTime(this.currentTime);
    },
    get formattedDuration() {
        return this.formatTime(this.duration);
    },

    // Aux
    rootElement: null,
    audioTags  : [],

    init(){
        this.rootElement = this.$el;
        this.$watch('tracks', () => {
            this.initPlayer();
        });
    },

    // REFS (cuando playAll = true, tendremos un array de <audio>)
    initPlayer() {
        if(this.tracks.length === 0) return;

        if (this.playAll) {
            // Cada track tendrá su propio <audio>
            this.audioTags = this.rootElement.querySelectorAll('audio');
            this.audioTags.forEach((audioEl, index) => {
                const isMaster = index === this.masterIndex;

                audioEl.addEventListener('timeupdate', () => {
                    if (index === this.currentIndex) {
                        this.currentTime = audioEl.currentTime;
                        this.duration = audioEl.duration || 0;
                        this.updateProgress();
                    }
                });

                // EVENTO "ended": si un track se acaba
                audioEl.addEventListener('ended', () => {
                    if (isMaster) {
                        this.stopAllTracks();
                    } else {
                        if (this.autoReplayOthers && this.isPlaying) {
                            audioEl.currentTime = 0;
                            audioEl.play();
                        } else {
                            audioEl.pause();
                        }
                    }
                });

                if (!isMaster) {
                    audioEl.volume = this.nonMasterVolume;
                }

                // Si autoplay = true, lo reproducimos al inicio
                if (this.autoplay) audioEl.play();
            });
        } else {
            // Un solo <audio> y cambiamos su src al track actual
            const mainAudio = this.$refs.mainAudio;
            mainAudio.src = this.tracks[this.currentIndex] || '';
            mainAudio.addEventListener('loadedmetadata', () => {
                this.duration = mainAudio.duration || 0;
            });
            mainAudio.addEventListener('timeupdate', () => {
                this.currentTime = mainAudio.currentTime;
                this.duration = mainAudio.duration || 0;
                this.updateProgress();
            });
            mainAudio.addEventListener('play', () => this.isPlaying = true);
            mainAudio.addEventListener('pause', () => this.isPlaying = false);

            // Si autoplay es true
            if (this.autoplay && this.tracks.length > 0) {
                mainAudio.play();
            }
        }
    },

    togglePlay() {
        if (this.playAll) {
            // Reproducir/pausar TODAS las pistas
            this.isPlaying = !this.isPlaying;
            this.audioTags.forEach((audioEl, index) => {
                if (this.isPlaying) audioEl.play();
                else audioEl.pause();
            });
        } else {
            const mainAudio = this.$refs.mainAudio;
            if (!this.isPlaying) mainAudio.play();
            else mainAudio.pause();
        }
    },

    prevTrack() {
        if (this.playAll) {
            this.currentIndex = (this.currentIndex === 0)
                ? this.tracks.length - 1
                : this.currentIndex - 1;
        } else {
            this.currentIndex = (this.currentIndex === 0)
                ? this.tracks.length - 1
                : this.currentIndex - 1;
            this.loadAndPlay();
        }
    },

    nextTrack() {
        if (this.playAll) {
            this.currentIndex = (this.currentIndex + 1) % this.tracks.length;
        } else {
            this.currentIndex = (this.currentIndex + 1) % this.tracks.length;
            this.loadAndPlay();
        }
    },

    //* Para "playAll = false" (modo playlist).
    loadAndPlay() {
        const mainAudio = this.$refs.mainAudio;
        mainAudio.src = this.tracks[this.currentIndex];
        mainAudio.play();
    },

    stopAllTracks() {
        if (!this.audioTags || this.audioTags.length === 0 ) return;
        this.audioTags.forEach(audioEl => {
            audioEl.pause();
            audioEl.currentTime = 0;
        });
        this.isPlaying = false;
        this.currentIndex = this.masterIndex;
        this.currentTime = 0;
        this.progressPercent = 0;
    },

    updateProgress() {
        if (this.duration > 0) {
            this.progressPercent = (this.currentTime / this.duration) * 100;
        } else {
            this.progressPercent = 0;
        }
    },

    // Formatear segundos a mm:ss
    formatTime(time) {
        if (!time || isNaN(time)) return '00:00';
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    },

    setTrackList(tracks){
        this.tracks = tracks;
        this.currentIndex = 0;
    }
});
